var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { useDataContext } from '@/shared/providers/DataProvider';
import userStorage from '@/shared/services/userStorage';
import { KPIOptions } from '../tasks/taskboard/constants';
export var DashboardContext = React.createContext(null);
export var useDashboardContext = function () {
    var ctx = useContext(DashboardContext);
    if (!ctx) {
        throw new Error('Wrap app with DashboardProvider');
    }
    return ctx;
};
var companyIdStorageKey = 'HomeDashboardCompanyId';
var taskKpiStorageKey = 'HomeDashboardTaskKPI';
var DashboardProvider = function (_a) {
    var _b, _c;
    var children = _a.children;
    var defaultCompany = useDataContext().defaultCompany;
    var _d = useState((_b = userStorage.getItem(companyIdStorageKey)) !== null && _b !== void 0 ? _b : defaultCompany === null || defaultCompany === void 0 ? void 0 : defaultCompany.id), companyId = _d[0], updateCompanyId = _d[1];
    var _e = useState((_c = userStorage.getItem(taskKpiStorageKey)) !== null && _c !== void 0 ? _c : KPIOptions.total), taskKpi = _e[0], updateTaskKpi = _e[1];
    var _f = useState(false), editMode = _f[0], setEditMode = _f[1];
    var setCompanyId = useCallback(function (value) {
        updateCompanyId(value);
        userStorage.setItem(companyIdStorageKey, value);
    }, [updateCompanyId]);
    var setTaskKpi = useCallback(function (value) {
        updateTaskKpi(value);
        userStorage.setItem(taskKpiStorageKey, value);
    }, [updateTaskKpi]);
    var value = useMemo(function () { return ({
        companyId: companyId,
        setCompanyId: setCompanyId,
        taskKpi: taskKpi,
        setTaskKpi: setTaskKpi,
        editMode: editMode,
        setEditMode: setEditMode,
    }); }, [companyId, setCompanyId, taskKpi, setTaskKpi, editMode]);
    return _jsx(DashboardContext.Provider, __assign({ value: value }, { children: children }));
};
export var withDashboardProvider = function (Component) { return function (_a) {
    var passThroughProps = __rest(_a, []);
    return (_jsx(DashboardProvider, { children: _jsx(Component, __assign({}, passThroughProps)) }));
}; };
export var injectDashboardContext = function (WrappedComponent) { return function (props) { return (_jsx(DashboardContext.Consumer, { children: function (service) { return _jsx(WrappedComponent, __assign({ dashboardContext: service }, props)); } })); }; };
export default DashboardProvider;
